// src/components/billing/RedeemGiftCardForm.jsx — shared gift redemption UI
// for /checkout and /settings/billing. Redemption credits the Stripe customer
// balance, so the caller refreshes whatever it displays via onRedeemed.
import React, { useState } from 'react';
import { formatMoney } from '../../lib/formatMoney';

const API = process.env.REACT_APP_API_URL;

const RedeemGiftCardForm = ({ onRedeemed }) => {
    const [code, setCode] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const submit = async () => {
        const value = code.trim();
        if (!value) return;
        setBusy(true);
        setError(null);
        setSuccess(null);
        try {
            const res = await fetch(`${API}/api/redeem_gift_card.php`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code: value }),
            });
            const data = await res.json();
            if (res.ok && data.status === 'success') {
                setSuccess(`${formatMoney(data.amount_cents, 'usd')} added to your account credit.`);
                setCode('');
                if (onRedeemed) onRedeemed(data);
            } else {
                setError(data.message || 'Could not redeem that card.');
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div>
            <div className="flex gap-2">
                <input
                    className="flex-1 bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-sm placeholder-neutral-600 focus:ring-2 focus:ring-cyan-500/60 focus:outline-none"
                    placeholder="Gift card code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />
                <button
                    type="button"
                    onClick={submit}
                    disabled={busy || !code.trim()}
                    className="px-4 py-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg disabled:opacity-50 transition-colors"
                >
                    {busy ? 'Checking…' : 'Redeem'}
                </button>
            </div>
            {error && <p className="text-red-400 text-xs mt-2">{error}</p>}
            {success && <p className="text-emerald-300 text-xs mt-2">{success}</p>}
        </div>
    );
};

export default RedeemGiftCardForm;
